import React, { createContext, useReducer } from 'react';

export const SET_STEPS = 'SET_STEPS';
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
export const SET_STEP_ACTIVE = 'SET_STEP_ACTIVE';
export const SET_STEP_VALID = 'SET_STEP_VALID';

interface StepperPayload {
    type: 'SET_STEPS' | 'SET_CURRENT_STEP' | 'SET_STEP_ACTIVE' | 'SET_STEP_VALID';
    payload?: StepState;
}

type Step = {
    isActive: boolean;
    isTouched: boolean;
    isValid: boolean;
};

interface StepState {
    steps: Step[];
    currentStep?: number;
    validationId?: number;
    isActive?: boolean;
    isValid?: boolean;
}

interface StepContext {
    state: StepState;
    dispatch: (context: StepperPayload) => void;
}

export const defaultStepperState: StepState = {
    steps: [],
    currentStep: 0,
};

export const reducer = (state = defaultStepperState, action: StepperPayload) => {
    const { steps } = state;
    const { type, payload } = action;

    switch (type) {
        case SET_CURRENT_STEP:
            return {
                ...state,
                currentStep: payload!.currentStep,
                steps:
                    steps &&
                    steps.map((content, i) =>
                        i === payload!.currentStep
                            ? { ...content, isActive: true, isTouched: true }
                            : content,
                    ),
            };
        case SET_STEP_ACTIVE:
            return {
                ...state,
                steps:
                    steps &&
                    steps.map((content, i) =>
                        i === payload!.currentStep
                            ? {
                                  ...content,
                                  isActive: payload?.isActive || false,
                              }
                            : content,
                    ),
            };

        case SET_STEP_VALID:
            return {
                ...state,
                steps:
                    steps &&
                    steps.map((content, i) =>
                        i === payload!.currentStep
                            ? {
                                  ...content,
                                  isValid: payload?.isValid || false,
                              }
                            : content,
                    ),
            };
        case SET_STEPS:
            return {
                ...state,
                steps: payload!.steps,
            };

        default:
            return state;
    }
};

export const StepperContext = createContext<StepContext>({
    state: defaultStepperState,
    dispatch: (context) => {},
});

// dispatch({ type: SET_STEPS, payload: { steps } })
// state

export const StepperProvider: React.FC = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, defaultStepperState);

    return (
        <StepperContext.Provider value={{ state, dispatch }}>{children}</StepperContext.Provider>
    );
};
